export const CommonUseData = [
  {
    title: "Website Translation and Localization Services ",
    // subTitle:"Translation Services",
    detail:
      "We both translate for websites and localize websites. If you're looking to create a multilingual website, translation services will be necessary for language support in these websites. Tomedes can localize and translate for your eCommerce website, your content writing blog, your tech app, and more. Why not get in touch with us today?",
    link: "/website-translation.php",
  },
  {
    title: "Legal Translation Services",
    // subTitle:" Translation Services",
    detail:
      "If you need translations for your agreements, contracts, patents, and affidavits, our legal translators can help you out. We also provide notarized translations and certified translations. Your legal documents are assured of passing the standards of any court of law. Don't trust just any translator with your legal documents, but a Tomedes legal translator.",
    link: "/legal-translation.php",
  },
  {
    title: "Technical Translation Services",
    // subTitle:" Translation Services",
    detail:
      "Technical translation services are important for the tech, science, and other industries. Technical translations are highly specialized, with specific terminologies in accordance with the industry. That's why Tomedes technical translators have both the linguistic rigor and the technical prowess to get the job done.",
    link: "/technical-translation.php",
  },
  {
    title: "Medical Translation Services",
    // subTitle:" Translation Services",
    detail:
      "Medical translators and interpreters can turn your records, lab reports, and patient information into verified translations, whether you're a physician, in the hospice business or in MedTech. Medical interpreters, meanwhile, can help you communicate effectively in whatever language you need.",
    link: "/medical-translation.php",
  },
  {
    title: "Financial Translation Services",
    // subTitle:" Translation Services",
    detail:
      "In traditional finance and new forms of financial businesses like cryptocurrency, you may need a financial translation expert to fulfill your translation needs. Good thing Tomedes is equipped with a global network of financial translators who know how to translate even the most complex reports.",
    link: "/financial-translation.php",
  },
  {
    title: "Interpretation Services",
    // subTitle:" Translation Services",
    detail:
      "Interpretation services are making it easier to communicate with each other even using different languages. At Tomedes, medical, legal, and technological interpreters are on hand to provide consecutive, simultaneous and other types of interpreting services. In San Francisco, what more could you ask for?",
    link: "/interpretation-services",
  },
];
